import { useState, useEffect } from "react";
import { toast } from "sonner";
import { getQuestionBankQuestions } from "../services/questionBankService";

const useQuestionbankQuestions = (topicId) => {
  const [questions, setQuestions] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuestion = async () => {
      try {
        const data = await getQuestionBankQuestions(topicId);  
        setQuestions(data);
      } catch (error) {
        console.error("Error fetching quiz details:", error);
        if(error.status === 404){
          setError('Quiz not found')
          toast.error("Quiz not found")
        } else {
          setError('Something went wrong. Failed to load quiz data...')
          toast.error("Failed to load quiz details")
        }
      } finally {
        setLoading(false);
      }
    };

    if (topicId) {
      fetchQuestion();
    }
  }, [topicId]);

  return {
    questions,
    error,
    loading,
    setLoading,
  };
};

export default useQuestionbankQuestions;
